import React from 'react'
import { GET_LIST } from 'react-admin'

import dataProvider from '../../../providers'
import { getResource } from '../../../config/resources'

import CompetitionsList from './sections/competitions'
import MobileAppsList from './sections/mobileapps'
import Rrss from './sections/rrss'
import HomeState from './sections/homestate'
// import GuestMode from './sections/guestmode'
import AdsSpacesList from './sections/adsspaces'
import TransfersConfig from './sections/transfersConfig'
import ChatbotConfig from './sections/chatbotConfig'

class AppManagement extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      appConfig: null,
      appConfigLoading: false,
      chatbotConfig: null,
      chatbotConfigLoading: false,
    }
  }

  componentDidMount() {
    this.getGlobalData('APP_CONFIG', 'appConfig')
    this.getGlobalData('CHATBOT_CONFIG', 'chatbotConfig')
  }

  getGlobalData = (name, key) => {
    this.setState({ [`${key}Loading`]: true })
    dataProvider(GET_LIST, getResource('transversal', 'globaldatas'), {
      sort: {
        field: 'id',
        order: 'DESC',
      },
      filter: {
        name,
      },
      pagination: { page: 1, perPage: 20 },
    }).then((res) => {
      this.setState({ [key]: res.data[0], [`${key}Loading`]: false })
    })
  }

  render() {
    return (
      <>
        <CompetitionsList />
        <MobileAppsList />
        <Rrss />
        <HomeState data={this.state.appConfig} loading={this.state.appConfigLoading} />
        {/* <GuestMode data={this.state.appConfig} loading={this.state.appConfigLoading} /> */}
        <AdsSpacesList />
        <TransfersConfig data={this.state.appConfig} loading={this.state.appConfigLoading} />
        <ChatbotConfig data={this.state.chatbotConfig} loading={this.state.chatbotConfigLoading} />
      </>
    )
  }
}

export default AppManagement
